import { PayoffGraphProps } from 'components/shared/Charts/PayoffGraph';
import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useTranslateForm } from 'hooks/use-translate-payoff';
import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { JointLineScatterChartFieldMetadata } from 'models/forms/fields';
import { useCallback } from 'react';
import { PayoffGraphCollapseCard } from 'routes/essential-workspace/components/form/fields/payoff-graph/payoff-graph-collapse-card';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';
import { isPayoffGraphHiddenInEssentialWorkspaceTab } from 'state/selectors';
import { toggleEssentialWorkspacePayoffGraphThunk } from 'state/workspaces/essential/thunks';

export function PayoffGraphField({ id, translationKey }: JointLineScatterChartFieldMetadata) {
  const dispatch = useThunkDispatch();

  const tabId = useAssertedActiveTabId();
  const isCollapsed = useAppSelector(state => isPayoffGraphHiddenInEssentialWorkspaceTab(state, tabId));

  const [value] = useFormFieldData<Nullable<PayoffGraphProps>>(id);

  const { translateLabel } = useTranslateForm();
  const label = translateLabel(translationKey ?? id);

  const handleOnToggle = useCallback(() => {
    dispatch(toggleEssentialWorkspacePayoffGraphThunk(tabId));
  }, [dispatch, tabId]);

  return <PayoffGraphCollapseCard value={value} label={label} onToggle={handleOnToggle} isCollapsed={isCollapsed} />;
}
